<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    mobile-breakpoint="960"
    app
    width="210"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img :gradient="`to bottom, ${barColor}`" v-bind="props" />
    </template>

    <v-divider class="mb-1" />

    <v-list dense nav>
      <a v-if="branding.logo" href="/patients/" style="text-decoration: none">
        <v-list-item style="width: 80%;">
          <v-img :src="branding.logo" />
        </v-list-item>
      </a>
      <router-link v-else to="/patients/" style="text-decoration: none">
        <v-list-item>
          <v-list-item-avatar class="align-self-center" color="white" contain>
            <v-img src="https://demos.creative-tim.com/vuetify-material-dashboard/favicon.ico" max-height="30" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="display-1" v-text="profile.title" />
          </v-list-item-content>
        </v-list-item>
      </router-link>
    </v-list>

    <v-divider class="mb-2" />

    <v-list expand nav>
      <div />

      <template v-for="(item, i) in menuItemsWithDashboards">
        <base-item-group v-if="item.children && item.children.length" :key="`group-${item.title}-${i}`" :item="item">
        </base-item-group>

        <base-item v-else :key="`item-${item.title}-${i}`" :item="item" />
      </template>

      <div />
    </v-list>
    <div class="drawer-footer">
      <BaseSocketStatus></BaseSocketStatus>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import menuItems from "@/configs/patients-menu";
import { getBrandingConfig } from "@/config";
import BaseSocketStatus from "@/components/base/SocketStatus.vue";

export default {
  name: "CorePatientsDrawer",

  components: { BaseSocketStatus },

  props: {
    expandOnHover: {
      type: Boolean,
    },
  },

  data: () => ({
    dashboardsLoading: false,
  }),

  computed: {
    branding() {
      return getBrandingConfig();
    },
    ...mapState(["barColor", "barImage"]),
    customer() {
      return this.$store.state.customer.profile;
    },
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      },
    },

    allowEditSchedule() {
      return this.$store.state.auth.profile.schedule_editor_flag || this.$store.state.auth.profile.own_schedule_editor_flag;
    },

    currentDashboards() {
      return this.$store.state.auth.dashboards || [];
    },

    menuItemsWithDashboards() {
      const dashboards = this.currentDashboards;
      const itemsKey = `stats-${dashboards.length}`;

      const items = menuItems.map(item => {
        const { children, ...rest } = item;

        if (item.title === "Statistics" && dashboards.length > 0) {
          return {
            ...rest,
            title: this.$t(item.title),
            children: dashboards.map(d => ({
              title: d.name,
              to: String(d.id),
            })),
            _key: itemsKey,
          };
        }

        const mapped = {
          ...rest,
          title: this.$t(item.title),
          _key: item.title,
        };

        if (children) {
          mapped.children = children.map(child => ({
            ...child,
            title: this.$t(child.title),
          }));
        }

        return mapped;
      });

      if (!this.allowEditSchedule) {
        return items.filter(el => el.to !== "/patients/schedule/");
      }

      return items;
    },

    profile() {
      return {
        avatar: true,
        title: this.$t("avatar"),
      };
    },
  },

  mounted() {
    this.loadDashboards();
  },

  methods: {
    async loadDashboards() {
      const existing = this.$store.state.auth.dashboards;
      if (existing && existing.length > 0) {
        return;
      }

      if (this.dashboardsLoading) return;
      this.dashboardsLoading = true;

      try {
        const doctorId = this.$store.state.auth.id;
        const { data } = await this.$http.get(`/v1/users/${doctorId}/dashboards`);
        this.$store.commit("auth/SET_DASHBOARDS", data.dashboards || []);
      } catch (e) {
        console.error("Failed to load dashboards:", e);
      }
    },
  },
};
</script>

<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'

#core-navigation-drawer
  .drawer-footer
    color: #fff
    padding: 15px
    margin-top: auto

  .v-list-group__header.v-list-item--active:before
    opacity: .24

  .v-navigation-drawer__content
    display: flex
    flex-direction: column
    width: 100%

  .v-list-item
    &__icon--text,
    &__icon:first-child
      justify-content: center
      text-align: center
      width: 20px

      +ltr()
        margin-right: 24px
        margin-left: 12px !important

      +rtl()
        margin-left: 24px
        margin-right: 12px !important

  .v-list--dense
    .v-list-item
      &__icon--text,
      &__icon:first-child
        margin-top: 10px

  .v-list-group--sub-group
    .v-list-item
      +ltr()
        padding-left: 8px

      +rtl()
        padding-right: 8px

    .v-list-group__header
      +ltr()
        padding-right: 0

      +rtl()
        padding-right: 0

      .v-list-item__icon--text
        margin-top: 19px
        order: 0

      .v-list-group__header__prepend-icon
        order: 2

        +ltr()
          margin-right: 8px

        +rtl()
          margin-left: 8px
</style>
